import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { verticalSigningQueryKeys } from "./queryKeys"
import { useVerticalSigningQuery } from "./useVerticalSigningQuery"


export function useVerticalSignPoles(parameters = {}, config = {}) {
    const url = "vertical_sign_poles/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = verticalSigningQueryKeys["layer"](queryParameters)

    return useVerticalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}

export const useExistingVerticalSign = (poleId, onError) => {

    const queryClient = useQueryClient()

    const poleQueryKey = verticalSigningQueryKeys["pole"](poleId)
    poleQueryKey.pop()
    const layerQueryKey = verticalSigningQueryKeys["layer"]()
    layerQueryKey.pop()

    const signPolesDataFromLayer = queryClient.getQueriesData({ queryKey: layerQueryKey })
    const signPolesData = queryClient.getQueriesData({ queryKey: poleQueryKey })

    const existingInSignData = signPolesData?.some(([_, signPoleData]) => {
        return (signPoleData?.id || signPoleData?.uuid) === poleId
    })
    const existingInLayerData = signPolesDataFromLayer?.some(([_, signPolesDataFromLayer]) => {
        if (signPolesDataFromLayer?.features) {
            return signPolesDataFromLayer?.features?.some(signPole => signPole.id === poleId)
        } else {
            return signPolesDataFromLayer?.some(signPole => signPole.uuid === poleId)
        }
    })
    const existingSignPoleInCache = existingInSignData || existingInLayerData

    const { isLoading, isError } = useVerticalSignPole(poleId, {}, {
        enabled: !existingSignPoleInCache,
        onError,
    })

    return (!(isLoading || isError) || existingSignPoleInCache)
}

export function useVerticalSignPole(poleId, parameters = {}, config = {}) {
    const url = `vertical_sign_poles/${poleId}/`
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = verticalSigningQueryKeys.pole(poleId, parameters)

    return useVerticalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            autoRefetch: true,
            ...config,
        },
    )
}